<template>
    <div class="h-full w-full flex flex-col bg-white shadow-lg relative">
        <div class="absolute -top-4 w-full flex justify-center">
            <div class="bg-primary text-white w-1/3 h-8 animate-pulse"></div>
        </div>
        <div class="h-full w-full flex flex-col px-8 pt-8 pb-8">
            <h1 class="text-center text-xl h-8 bg-gray-600 animate-pulse"></h1>
            <div class="flex-auto flex flex-col justify-end mt-8">
                <div class="flex justify-center">
                    <p class="h-4 bg-gray-300 w-2/5 animate-pulse"></p>
                </div>
            </div>
        </div>
    </div>
</template>